import { render, staticRenderFns } from "./OnboardingPrimaryLanguage.vue?vue&type=template&id=fb333e94&"
import script from "./OnboardingPrimaryLanguage.vue?vue&type=script&lang=js&"
export * from "./OnboardingPrimaryLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports